import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';
import { PublicCartItemProductAttributeResponse } from './public-cart-item-product-attribute.response';

@jsonObject
export class PublicCartItemAttributeResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly value!: string;

  @jsonMember(PublicCartItemProductAttributeResponse)
  public readonly productAttribute!: PublicCartItemProductAttributeResponse;
}
